import React from 'react';
import PropTypes from 'prop-types';

/**
 * DealerInfoBlock — renders dealer name and address.
 * Pure presentational component; receives all data as props.
 */
const DealerInfoBlock = ({ accountName, addressLine1, addressLine2 }) => (
	<div
		className="ws-nav-drawer__dealer-info py-4"
		data-testid="dealer-info-block"
	>
		<div
			className="ws-nav-drawer__dealer-info-inner"
			data-testid="dealer-info-inner"
		>
			{accountName && (
				<p className="ws-nav-drawer__dealer-name ddc-font-size-large mb-3">
					{accountName}
				</p>
			)}
			{(addressLine1 || addressLine2) && (
				<address className="ws-nav-drawer__dealer-address mb-3">
					{addressLine1 && <span>{addressLine1}</span>}
					{addressLine2 && <span>{addressLine2}</span>}
				</address>
			)}
		</div>
	</div>
);

DealerInfoBlock.propTypes = {
	accountName: PropTypes.string,
	addressLine1: PropTypes.string,
	addressLine2: PropTypes.string
};

export default DealerInfoBlock;
